var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.87891 0.246094L10.2539 4.62109C10.418 4.80339 10.5 5.01302 10.5 5.25C10.5 5.48698 10.418 5.69661 10.2539 5.87891C10.0716 6.04297 9.86198 6.125 9.625 6.125C9.38802 6.125 9.17839 6.04297 8.99609 5.87891L6.125 2.98047V11.375C6.125 11.6302 6.04297 11.8398 5.87891 12.0039C5.71484 12.168 5.50521 12.25 5.25 12.25C4.99479 12.25 4.78516 12.168 4.62109 12.0039C4.45703 11.8398 4.375 11.6302 4.375 11.375V2.98047L1.50391 5.87891C1.32161 6.04297 1.11198 6.125 0.875 6.125C0.638021 6.125 0.428385 6.04297 0.246094 5.87891C0.0820312 5.69661 0 5.48698 0 5.25C0 5.01302 0.0820312 4.80339 0.246094 4.62109L4.62109 0.246094C4.80339 0.0820312 5.01302 0 5.25 0C5.48698 0 5.69661 0.0820312 5.87891 0.246094Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.5a7e6af8.svg";
export { ForwardRef as ReactComponent };